import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid2';
import { useTheme } from '@mui/system';

const userTestimonials = [
  {
    avatar: '/testimonials/maria.jpg',
    name: 'Maria Silva',
    occupation: 'Cabeleireira',
    testimonial:
      'A Nextalk revolucionou meu negócio! Agora consigo agendar clientes 24h por dia, mesmo quando estou ocupada atendendo. Minha agenda está sempre cheia e as clientes adoram a praticidade.',
  },
  {
    avatar: '/testimonials/joao.jpg',
    name: 'João Santos',
    occupation: 'Dentista',
    testimonial:
      'Excelente custo-benefício! O assistente faz marcação de consultas, responde dúvidas frequentes e ainda me ajuda a reativar pacientes antigos. Melhor investimento que fiz para meu consultório.',
  },
  {
    avatar: '/testimonials/ana.jpg',
    name: 'Ana Oliveira',
    occupation: 'Loja de Roupas Online',
    testimonial:
      'Implementei a inteligência artificial e foi incrível! Ela responde dúvidas sobre produtos e entregas na hora. Minhas vendas aumentaram e os clientes não precisam mais esperar eu estar disponível.',
  },
  {
    avatar: '/testimonials/carlos.jpg',
    name: 'Carlos Ferreira',
    occupation: 'Personal Trainer',
    testimonial:
      'Estou economizando muito tempo e consigo focar nos alunos que já tenho. Minha taxa de conversão aumentou significativamente.',
  },
  {
    avatar: '/testimonials/patricia.jpg',
    name: 'Patrícia Costa',
    occupation: 'Consultora Imobiliária',
    testimonial:
      'Fantástico! Os clientes passam por uma triagem inicial e já agendam visitas. Consigo atender muito mais clientes sem esforço. Superou todas as minhas expectativas.',
  },
  {
    avatar: '/testimonials/roberto.jpg',
    name: 'Roberto Almeida',
    occupation: 'Dono de Restaurante',
    testimonial:
      'Nossos clientes adoram fazer pedidos pelo WhatsApp e o meu assistente não deixa ninguém sem resposta. O melhor é que ele já integra com nosso sistema de delivery!',
  },
];

const whiteLogos = [
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560628e8573c43893fe0ace_Sydney-white.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f4d520d0517ae8e8ddf13_Bern-white.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f46794c159024c1af6d44_Montreal-white.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/61f12e891fa22f89efd7477a_TerraLight.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560a09d1f6337b1dfed14ab_colorado-white.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f5caa77bf7d69fb78792e_Ankara-white.svg',
];

const darkLogos = [
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560628889c3bdf1129952dc_Sydney-black.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f4d4d8b829a89976a419c_Bern-black.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f467502f091ccb929529d_Montreal-black.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/61f12e911fa22f2203d7514c_TerraDark.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/6560a0990f3717787fd49245_colorado-black.svg',
  'https://assets-global.website-files.com/61ed56ae9da9fd7e0ef0a967/655f5ca4e548b0deb1041c33_Ankara-black.svg',
];

const logoStyle = {
  width: '64px',
  opacity: 0.3,
};

export default function Testimonials() {
  const theme = useTheme();
  const logos = theme.palette.mode === 'light' ? darkLogos : whiteLogos;

  return (
    <Container
      id="testimonials"
      sx={{
        pt: { xs: 4, sm: 12 },
        pb: { xs: 8, sm: 16 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: { xs: 3, sm: 6 },
      }}
    >
      <Box
        sx={{
          width: { sm: '100%', md: '60%' },
          textAlign: { sm: 'left', md: 'center' },
        }}
      >
        <Typography
          component="h2"
          variant="h4"
          gutterBottom
          // sx={{ color: 'text.primary' }}
        >
          Histórias de Sucesso
        </Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          Veja como outros empreendedores estão transformando seus negócios com a Nextalk.
          Junte-se a eles e comece a automatizar seu atendimento hoje mesmo.
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {userTestimonials.map((testimonial, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index} sx={{ display: 'flex' }}>
            <Card
              variant="outlined"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                flexGrow: 1,
              }}
            >
              <CardContent>
                <Typography
                  variant="body1"
                  gutterBottom
                  sx={{ color: 'text.secondary' }}
                >
                  "{testimonial.testimonial}"
                </Typography>
              </CardContent>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <CardHeader
                  avatar={<Avatar alt={testimonial.name} src={testimonial.avatar} />}
                  title={testimonial.name}
                  subheader={testimonial.occupation}
                />
                {/* <img
                  src={logos[index]}
                  alt={`Logo ${index + 1}`}
                  style={logoStyle}
                /> */}
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}